import { UIIcon } from '../../config/icons';
import { XTaskProgress } from '../mdl/x-task';
import { UIButton } from '../ui/component/button';
import { UIChipInput } from '../ui/component/chip';
import { UITextInput } from '../ui/component/input';
import { UIProgressWheel } from '../ui/component/progress';
import { $el } from '../ui/elements';
import { UISVG, $svg } from '../ui/svg';
import { UIView, UIViewSpec } from '../ui/view';
import { $on } from '../y/events';
import { ySuggestEmail } from '../y/mail';

export class ABEmailCheck extends UIView {
    constructor(input: UITextInput | UIChipInput, right?: boolean) {
        super('div', 'tl-email-check ' + (right ? 'm-right' : 'm-left'));

        let commit: (suggestion: string) => void;

        const suggest = (suggestion?: string) => {
            this.ui_empty();
            if(suggestion) {
                this.ui_add([
                    'Menade du ',
                    new UIButton({
                        kind: 'k-text', classes: 'm-inline', title: suggestion, on_click: () => {
                            commit(suggestion);
                            this.ui_empty();
                        }
                    }),
                    '?'
                ]);
            }
        }

        if(input instanceof UITextInput) {
            commit = suggestion => { input.value = suggestion };

            $on(input, 'blur', () => {
                suggest(ySuggestEmail(input.value || ''));
            });

            $on(input, 'value', () => {
                suggest();
            });
        } else {
            let index = -1;
            let last_value: string[] = [];
            commit = suggestion => {
                if(index >= 0) {
                    last_value[index] = suggestion;
                    input.value = last_value;
                }
            };

            $on(input, 'value', value => {
                index = value.findIndex(s => !last_value.includes(s));
                if(index >= 0)
                    suggest(ySuggestEmail(value[index]));
                else
                    suggest();
                last_value = value.slice();
            });
        }
    }
}

export class ABSafePaymentBar extends UIView {
    constructor() {
        super('div', 'tl-safe-payment', [$el.ICON(UIIcon.LOCK_KEYHOLE), $el.I('Det här är en säker transaktion.')]);
    }
}

export class ABProgressView extends UIView {
    private _wheel: UIProgressWheel;
    private _text: HTMLSpanElement;

    constructor() {
        const wheel = new UIProgressWheel;
        const text = $el.SPAN('r-text');

        super('div', 'tl-progress-view', [wheel, text]);

        this._wheel = wheel;
        this._text = text;
    }

    set text(text: string) {
        this._text.textContent = text;
    }

    set progress(p: number) {
        this._wheel.progress = p;
    }

    set task_progress(p: XTaskProgress) {
        this._wheel.progress = p.total;
        if(p.step_name) {
            this._text.ui_empty([
                p.step_name,
                p.item_max > 0 && [$el.BR(), `${p.item}\u00a0/\u00a0${p.item_max}`],
                !!p.item_name && [$el.BR(), p.item_name]
            ]);
        }

    }

    complete(text: string) {
        this._wheel.progress = 1;
        this._text.textContent = text;
    }
}

export class TLInfinityLoader extends UISVG {
    constructor() {
        super('ui-loader', [187.3, 93.7]);

        const path = 'M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z'

        this.add($svg.PATH('r-back', path));
        this.add($svg.PATH('r-front', path));
    }
}

export function showLoader(where: UIViewSpec, until?: Promise<any>) {
    const loader = new TLInfinityLoader;
    where.ui_add(loader);
    if(until)
        until.then(() => { loader.remove() });
}
